import classnames from 'classnames';
import React from 'react';

import css from 'reactComponents/icons/defaultIconStyles.css';

export const IconCheckmarkRound = ({
    className = undefined,
    width = 16,
    height = 16,
    ...rest
}) => {
    return (
        <svg
            height={height}
            width={width}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 0C12.415 0 16 3.585 16 8C16 12.415 12.415 16 8 16C3.585 16 0 12.415 0 8C0 3.585 3.585 0 8 0ZM10.885 5.422C11.027 5.433 11.162 5.467 11.289 5.533C11.372 5.577 11.449 5.632 11.517 5.697C11.781 5.949 11.887 6.335 11.79 6.687C11.748 6.839 11.669 6.974 11.566 7.093C10.379 8.337 9.163 9.552 7.92 10.739C7.838 10.81 7.75 10.871 7.65 10.915C7.395 11.028 7.098 11.028 6.843 10.915C6.743 10.871 6.655 10.81 6.573 10.739C5.869 10.066 5.179 9.378 4.507 8.673C4.404 8.554 4.325 8.419 4.283 8.266C4.258 8.176 4.246 8.082 4.247 7.988C4.251 7.607 4.48 7.253 4.826 7.093C4.94 7.04 5.063 7.009 5.188 7.002C5.313 6.994 5.439 7.011 5.558 7.05C5.709 7.099 5.839 7.184 5.954 7.293L7.247 8.586C8.215 7.617 9.162 6.626 10.153 5.681C10.189 5.65 10.189 5.65 10.225 5.621C10.277 5.584 10.329 5.551 10.385 5.523C10.499 5.467 10.619 5.437 10.744 5.424C10.792 5.421 10.838 5.42 10.885 5.422Z"
            />
        </svg>
    );
};
export default IconCheckmarkRound;
